<ng-template #linkContent>
  <ng-content></ng-content>
</ng-template>

@if (isExternal()) {
  <a
    [class]="linkClass()"
    [attr.data-cy]="dataCy()"
    [href]="href()"
    [class.text]="contentType() === 'text'"
    [attr.rel]="relation()"
    [attr.target]="targetAttribute()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.tabindex]="tabIndex()"
    [attr.aria-disabled]="disabled() || null"
    (click)="onClick($event)"
  >
    <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
  </a>
} @else {
  <a
    [class]="linkClass()"
    [attr.data-cy]="dataCy()"
    [routerLink]="route()"
    [class.text]="contentType() === 'text'"
    [routerLinkActive]="routerActive()"
    [relativeTo]="relativeTo()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.tabindex]="tabIndex()"
    [attr.aria-disabled]="disabled() || null"
    (click)="onClick($event)"
  >
    <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
  </a>
}
